jQuery(function($) {
  const $body = $('body');

  // smooth scroll to anchors
  $("a[href*='#']").on("click", function(event) {
    const target = $($(this).attr("href").match(/#(.+)$/)[0]);

    if (target.length) {
      event.preventDefault();
      $("html, body").animate(
        {
          scrollTop: target.offset().top
        },
        800
      );
    }
  });

  // open/close Burger Menu
  const $headerBurger = $('.header__burger');
  if ($headerBurger.length) {
    const $lightLogo = $('.header__logo--light');
    const $darkLogo = $('.header__logo--dark');
    const $mobMenu = $('.header-mobile');

    function closeMainMenu() {
      $headerBurger.attr('aria-expanded', 'false');
      $lightLogo.removeClass('hidden');
      $darkLogo.addClass('hidden');
      $mobMenu.removeClass('active');
      $body.css('overflow', '');
    }

    $headerBurger.on('click', function() {
      if ($(this).attr('aria-expanded') === 'true') {
        closeMainMenu();
      } else {
        $(this).attr('aria-expanded', 'true');
        $lightLogo.addClass('hidden');
        $darkLogo.removeClass('hidden');
        $mobMenu.addClass('active');
        $body.css('overflow', 'hidden');
      }
    });

    $('.header-mobile a').on('click', function() {
      closeMainMenu();
    });

    $mobMenu.on('click', function(e) {
      if (e.target === e.currentTarget) {
        closeMainMenu();
      }
    });

    $(window).on('resize', function() {
      if ($(window).width() > 900 && $headerBurger.attr('aria-expanded') === 'true') {
        closeMainMenu();
      }
    });
  }

  // filling text animation
  const $fillingText = $('.home-about__filling-text');
  if ($fillingText.length) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const $this = $(entry.target);
          const $blackText = $this.find('.home-about__filling-text--black');
          const $greyText = $this.find('.home-about__filling-text--grey');

          const fullText = $greyText.text();
          let index = 0;

          function transferNextChar() {
            if (index < fullText.length) {
              const char = fullText.charAt(index);
              $blackText.append(char);
              index++;
              setTimeout(transferNextChar, 50);
            }
          }

          transferNextChar();
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    $fillingText.each(function () {
      observer.observe(this);
    });
  }

  // open/close links in the services section
  const $homeServLink = $('.home-serv__link');
  if ($homeServLink.length) {
    $homeServLink.on('mouseenter', function() {
      if ($(window).width() > 768) {
        $(this).attr('aria-expanded', 'true').find($('.home-serv__link-descr')).stop().slideDown();
      }
    });

    $homeServLink.on('mouseleave', function() {
      if ($(window).width() > 768) {
        $(this).attr('aria-expanded', 'false').find($('.home-serv__link-descr')).stop().slideUp();
      }
    });

    function hideLinkText() {
      $('.home-serv__link[aria-expanded="true"]').attr('aria-expanded', 'false');
      $('.home-serv__link-descr').slideUp();
    }

    $homeServLink.on('click', function(e) {
      if ($(window).width() < 769) {
        if (!e.target.classList.contains('home-serv__link-mob')) {
          e.preventDefault();
        }


        if ($(this).attr('aria-expanded') === 'false') {
          hideLinkText();
          $(this).attr('aria-expanded', 'true').find($('.home-serv__link-descr')).stop().slideDown();
        } else {
          $(this).attr('aria-expanded', 'false').find($('.home-serv__link-descr')).stop().slideUp();
        }
      }
    });

    $(window).on('resize', function() {
      hideLinkText();
    });
  }

  // filling footer marquee
  const $footerMarquee = $('.footer-marquee__img');
  if ($footerMarquee.length) {
    $(window).on('load', function() {
      const marqueeClone = $footerMarquee.eq(0).clone();
      
      let prevScrWidth = $(window).width();
      let marqueeWidth = $footerMarquee.eq(0).width();
      let resizeTimeout;
      let imagesCount = 1;

      function fillingFooterMarquee() {
        const screenWidth = $(window).width();

        const newImagesCount = marqueeWidth ? Math.ceil(screenWidth / marqueeWidth) + 1 : 1;

        if (newImagesCount !== imagesCount) {
          imagesCount = newImagesCount;

          $('.footer-marquee__string').empty();

          for (let mqi = 0; mqi < imagesCount; mqi++) {
            marqueeClone.clone().appendTo('.footer-marquee__string');
          }
        }
      }

      fillingFooterMarquee();

      $(window).on('resize', function() {
        const currentWidth = $(window).width();
        if (currentWidth !== prevScrWidth) {
          marqueeWidth = $('.footer-marquee__img').eq(0).width();

          clearTimeout(resizeTimeout);

          resizeTimeout = setTimeout(function () {
            prevScrWidth = currentWidth;
            fillingFooterMarquee();
          }, 200);
        }
      });
    });
  }

  // testimonials slider
  if ($('.testimonials').length) {
    new Swiper('.testimonials__items', {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      navigation: {
        prevEl: '.testimonials__items-prev',
        nextEl: '.testimonials__items-next',
      },
    });
  }

  // contact us validation
  const $contactUs = $('#contact-us');
  if ($contactUs.length) {
    $contactUs.on('submit', function(e) {
      e.preventDefault();

      const submitBtn = $(this).find('.contact-us__form-send');
      submitBtn.attr('disabled', 'true');

      const name = $(this).find('#name').val();
      const email = $(this).find('#email').val();
      const message = $(this).find('#message').val();
      const nonce = $(this).find('#contact-us-nonce').val();

      const data = {
        action: 'nlworks_contact_form',
        name,
        email,
        message,
        'contact-us-nonce': nonce
      }
      $.post(phpData.ajaxurl, data, function(response) {
        submitBtn.removeAttr('disabled');

        if (response.success) {
          window.location.href = response.data.address;
        } else {
          const errors = response.data || {};

          if (errors.field === 'form') {
            alert(errors.message);
            console.error(errors.reason);
          } else {
            errors.forEach(error => {
              switch (error.field) {
                case 'name':
                  $contactUs.find('#name-error').text(error.message);
                  $contactUs.find('#name').addClass('error');
                  $contactUs.find('#name').attr('aria-invalid', 'true');
                  break;

                case 'email':
                  $contactUs.find('#email-error').text(error.message);
                  $contactUs.find('#email').addClass('error');
                  $contactUs.find('#email').attr('aria-invalid', 'true');
                  break;

                default:
                  break;
              }
            })
          }
        }
      });
    });

    $body.on('focus', 'input.error', function() {
      $(this).removeClass('error');
    });
  }
});